import type { InvoiceDetail } from '../useQueryInvoiceDetail/types';
import type { ReplaceInvoiceAssigneesVariables } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

import { zodReplaceInvoiceAssigneesPayloadSchema } from './validations';

/**
 * Replaces all assignees on an invoice.
 *
 * @param variables - Invoice identifier and replacement assignee ids.
 * @returns The updated invoice detail.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/replace_invoice_assignees_invoices__invoice_id__assignees_put
 */
export async function replaceInvoiceAssignees({
  invoiceId,
  payload,
}: ReplaceInvoiceAssigneesVariables): Promise<InvoiceDetail> {
  return vestigasApi
    .put(ENDPOINT.INVOICE.REPLACE_ASSIGNEES(invoiceId), {
      json: payload,
      validate: {
        body: zodReplaceInvoiceAssigneesPayloadSchema,
        isResponseSensitive: true,
        response: zodInvoiceDetailSchema,
      },
    })
    .json<InvoiceDetail>();
}
